import { Component, Input } from '@angular/core';

@Component({
  selector: 'ln-topic-paragraph',
  imports: [],
  templateUrl: './topic-paragraph.component.html',
  styleUrl: './topic-paragraph.component.css',
})
export class TopicParagraphComponent {
  @Input({ required: true }) tittle!: string;
  @Input({ required: true }) text!: string;
}
